module.exports = __webpack_public_path__ + "static/media/pt.03f36e39.svg";